import { useEffect, useState, type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { BookingStore } from 'store';
import { Button, Modal } from '@g2u/ui-kit';
import { Alert } from 'antd';

import styles from './booking-flow.module.scss';

const bookingPaths = ['/booking/location', '/booking/technician', '/booking/payment'];

export const BookingFlow: FC = observer(() => {
  const { step } = BookingStore;
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [maxStep, setMaxStep] = useState(step);

  useEffect(() => {
    const inBookingFlow = bookingPaths.includes(location.pathname);
    if (step < 4 && maxStep >= 4 && inBookingFlow) {
      setShowModal(true);
    } else {
      setShowModal(false);
      setMaxStep(step);
    }

    if (location.pathname.includes('/booking/start')) setMaxStep(0);
  }, [location.pathname, step, maxStep]);

  const navigate = useNavigate();
  const goToDashboard = () => navigate('/dashboard');

  return (
    <>
      <Outlet />
      <Modal.$
        footer={null}
        closable={false}
        open={showModal}
        dataTestId="modal-return-to-dashboard"
        wrapClassName={styles.booking_flow__modal}
      >
        <Alert
          message="This job has already been booked"
          description="Please return to Dashboard to start another"
          type="warning"
          action={
            <Button.$ type={Button.Type.Primary} onClick={goToDashboard} dataTestId="btn-return-to-dashboard">
              Return to Dashboard
            </Button.$>
          }
          showIcon
        />
      </Modal.$>
    </>
  );
});
